let env = {};

env.baseURL = 'https://api.ponto.innovareti.com.br/api/v1/';
env.normalURL = 'https://api.ponto.innovareti.com.br/';

export default env



// WEBPACK FOOTER //
// ./src/config/env.js